import React from 'react';
import styled from 'styled-components';
import {labels} from '../../../../../util/utils';
import NoDataPlaceholder from '../../../../Common/ResourceWithLink/NoDataPlaceholder';

export default function MultiEntityListNoEntities(props) {
	const {setShowModal} = props;

	const handleCreateMultiEntity = () => {
		setShowModal(true);
	};

	return (
		<StyledMultiEntityListNoEntities className="StyledMultiEntityListNoEntities">
			<NoDataPlaceholder
				className="create-entity-link"
				placeholder={labels.noEntitiesAvailable}
				onPlaceholderClickConfig={{noEntitiesAvailableCreateNewLink: handleCreateMultiEntity}}
			/>
		</StyledMultiEntityListNoEntities>
	);
}

const StyledMultiEntityListNoEntities = styled.section`
	width: 100%;
	margin-bottom: var(--px-20);
	padding: var(--px-20) var(--px-15) var(--px-20) var(--px-15);
	border-radius: var(--px-12);
	border: var(--px-1) solid var(--neutrals-200);
	font-size: var(--px-14);
	background: var(--neutrals-00white);
	min-height: var(--px-134);
	display: flex !important;
	justify-content: center;
	.create-entity-link {
		a {
			font-size: var(--px-14);
		}
	}
	.StyledResourceWithLink {
		display: flex !important;
		flex-direction: row !important;
		.createClickableTextLink {
			margin: 0 var(--px-5);
		}
	}
`;
